module.exports = __webpack_public_path__ + "static/portfolio-worldwireradio-ae18c17dbf1a792401d8f0034f97c300.jpg";